import { TitleFormSectionSubTitle } from '@dataplace.ai/ui-components/atoms'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div(({ theme }) => {
  const { palette } = theme
  return css`
    display: flex;
    flex-direction: column;
    padding: 1.25rem 1.5rem;
    background-color: ${palette.light.white};
  `
})
export const NoItems = styled.div`
  width:100%;
  display: flex;
  justify-content: center;
`

export const FilterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`

export const TableWrapper = styled.div`
    margin-bottom: 1rem;
`

export const MapWrapper = styled.div<{ $isPrinting: boolean }>(({ $isPrinting }) => css`
  margin: 1rem 0;
  width: 100%;
  height: 300px;

  ${$isPrinting && css`margin: 0 !important;`}
`)

export const CheckboxWrapper = styled.div(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
      display: flex;
    align-items: center;
      color: ${palette.blue};
      font-size: ${typography.tiny.pt_12_medium_upper.fontSize};
      font-weight: ${typography.tiny.pt_12_medium_upper.fontWeight};
      line-height: ${typography.tiny.pt_12_medium_upper.lineHeight};

      > :first-child {
        margin-right: 0.5rem
      }
    `
})

export const StyledTitleFormSectionSubTitle = styled(TitleFormSectionSubTitle)(
  ({ theme: { palette } }) => css`
    border-top: 1px solid ${palette.light.darker};
    padding-top: 2rem;
    margin-bottom: 0;
  `,
)

export const StyledDistanceSpan = styled.span`
  display: flex;
  justify-content: flex-end;
`
